import type { NewSearchDto, SavedSearchDto } from "app/pages/sales-intelligence/sub-modules/advanced-search/types/dto";
import type { IFetchService } from "app/services/fetchService";
import { NoCacheHeaders } from "app/services/fetchService";

import { BASE_SAVED_SEARCH_URL } from "./const";

export const createSavedSearchesApiService = (fetchService: IFetchService) => {
    return {
        saveNewSearch: (dto: NewSearchDto): Promise<SavedSearchDto> => {
            return fetchService.post(BASE_SAVED_SEARCH_URL, dto);
        },
        updateSearchById(id: string, dto: NewSearchDto): Promise<SavedSearchDto> {
            return fetchService.put(`${BASE_SAVED_SEARCH_URL}/${id}`, dto);
        },
        fetchSearchById(id: string): Promise<SavedSearchDto> {
            return fetchService.get(`${BASE_SAVED_SEARCH_URL}/${id}`, undefined, {
                headers: NoCacheHeaders,
            });
        },
    };
};
